<template>
    <v-container class="h-100">
      <v-card v-if="showClientDetails==false" class="card-container">
        <v-card-title>
          <v-row>
            <v-col v-if="canEdit" cols="auto">
              <v-btn
                      dense
                      color="var(--color-blue)"
                      @click="showAddModal"
                      dark
              >
                <span class="btn-text"><v-icon dark>add</v-icon> Добавить клиента</span>
              </v-btn>
            </v-col>
            <v-col v-if="canEdit" cols="auto">
              <v-btn
                      dense
                      color="var(--color-blue)"
                      outlined
                      dark
                      @click="showSubscript"
              >
                <span class="btn-text"><v-icon dark>mdi-printer</v-icon> Бланк договора</span>
              </v-btn>
            </v-col>
            <v-col v-if="canEdit" cols="auto">
              <v-btn
                      dense
                      color="var(--color-blue)"
                      outlined
                      dark
                      @click="showAgreements"
              >
                <span class="btn-text"><v-icon dark>mdi-printer</v-icon> Соглашение</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-text-field
                      class="search-block"
                      v-model="search"
                      prepend-inner-icon="mdi-magnify"
                      single-line
                      solo
                      placeholder="Поиск клиента"
                      dense
                      hide-details
              />
            </v-col>
            <v-col cols="auto">
              <span class="subheader-label">Фильтр:</span>
            </v-col>
            <v-col
                    cols="8"
                    sm="2"
                    md="2"
                    lg="2"
                    xl="2">
              <v-select
                      v-model="selectedPackages"
                      multiple
                      item-text="name"
                      item-value="id"
                      solo
                      dense
                      hide-details
                      :items="packages"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                          ripple
                          @click="toogleAllBonuses"
                  >
                    <v-list-item-action>
                      <v-icon :color="selectedPackages.length > 0 ? 'indigo darken-4' : ''">
                        {{ icon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Выбрать все
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <div v-if="likesAllBonuses||selectedPackages.length==0">
                    <span v-if="index === 0">Все</span>
                  </div>
                  <div v-else>
                    <span v-if="index === 0">{{ item.name }}</span>
                    <span
                            v-if="index === 1"
                            class="grey--text caption"
                    >
                                        (+{{ selectedPackages.length - 1 }})
                                    </span>
                  </div>
                </template>
              </v-select>
            </v-col>
            <v-spacer v-if="!canEdit"></v-spacer>
          </v-row>

        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
          <v-data-table
                  :loading="loading"
                  no-data-text="Нет элементов"
                  no-results-text="Не найдено элементов"
                  loading-text="Загрузка данных"
                  calculate-widths
                  :items-per-page="filteredItems.length"
                  :items="filteredItems"
                  :headers="fields"
                  :search="search"
                  height="100%"
                  hide-default-footer
                  class="elevation-1 h-100"
          >
            <template v-slot:item.carName="{item}">
             <span>{{item.carMark+' '+item.carModel+' '+item.carYear}}</span>
            </template>
            <template v-slot:item.registerDateTime="{item}">
              <span>{{formatDateMounthName(item.registerDateTime)}}</span>
            </template>
            <template v-slot:item.clientStatusName="{item}">
              <span :class="{'client-st1':item.clientStatusCode=='CS01','client-st2':item.clientStatusCode=='CS02','client-st4':item.clientStatusCode=='CS04'}">{{item.clientStatusName}}</span>
            </template>
            <template v-slot:item.bonusPacketName="{item}">
              <div :class="{'bonus-container':true,'bonus-1':item.bonusPacketCode=='BP01','bonus-2':item.bonusPacketCode=='BP02', 'bonus-3':item.bonusPacketCode=='BP03','bonus-0':item.bonusPacketCode=='BP00'}"><div>{{item.bonusPacketName}}</div></div>
            </template>
            <template v-slot:item.edit="{item}">
              <v-btn icon @click="showDetails(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <clientDetails v-else :item="selected" @hideDetails="hideDetails"></clientDetails>
      <addClientModal :show="addModal" @close="closeAddModal"></addClientModal>


    </v-container>

</template>

<script>
  import mapper from 'automapper'
  import { mapGetters } from 'vuex';
  import axios from 'axios'
  const addClientModal = ()=> import('../components/Clients/AddClientModal')
  const clientDetails= ()=>import('../components/Clients/ClientInfo')
  const docUrl=process.env.VUE_APP_DOCS

    export default {
        name: "UserRegister",
        components:{addClientModal, clientDetails},
      data() {
          return {
              showClientDetails: false,
              loading: false,
              errors: [],
              selectedPackages: [],
              search: "",
              selected: null,
              identityModel: {
                  login: null,
                  email: null,
                  phoneNumber: null,
                  password: null,
                  userName: null,
                  isClient: true,
                  isAdministrator: false,
                  organizationId: null,
                  webSite: '',
                  canAddUsers: false,
                  canManageBonuses: false,
                  canEcxecuteRequests: false
              },
              editClientModel: {
                  id: null,
                  account: null,
                  fullName: null,
                  eMail: null,
                  //password: null,
                  identityId: null,
                  //pushEnable:true,
                  isActive: true,
                  organizationId: null,
                  organization: null,
                  carModelId: null,
                  carModel: null,
                  carMarkId: null,
                  carMark: null,
                  carYear: 0
              },
              addModal: false,

          }
      },
      created(){
        this.$store.dispatch("Clients/loadMobileUsers").catch(err=>{
          console.log(err)
          this.$bvToast.toast(err.message, {
            title: `Ошибка загрузки списка пользователей!`,
            variant: "danger",
            toaster: 'b-toaster-bottom-right',
            autoHideDelay: 3000,
            solid: true
          })
        });

        //получить список бонусных пакетов
          this.$store.dispatch("Bonuses/loadBonusPackages").catch(err=>{
              console.log(err)
              this.$bvToast.toast(err.message, {
                  title: `Ошибка загрузки списка пользователей!`,
                  variant: "danger",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 3000,
                  solid: true
              })
          });

        this.$store.dispatch("Cars/loadMarks").catch((err) => {
          console.log(err)
          this.$bvToast.toast(err.message, {
            title: `Ошибка загрузки марок авто!`,
            variant: "danger",
            toaster: 'b-toaster-bottom-right',
            autoHideDelay: 3000,
            solid: true
          })
        });

        mapper.createMap("Client", "editClientModel")
          .forMember('password', function () {
            this.ignore();
          });

        mapper.createMap("editMobileUserModel", "identityModel")
          .forMember('login', function () {
            this.mapFrom('account')
          })
          .forMember('userName', function () {
            this.mapFrom('fullName')
          })
          .forMember('isAdministrator', function () {
            this.ignore()
          })
          .forMember('isClient', function () {
            this.ignore()
          })
          .forMember('webSite', function () {
            return null
          })
          .forMember('phoneNumber', function () {
            this.mapFrom('account')
          })
          .forMember('email', function () {
            this.mapFrom('eMail')
          })
          .forMember('canAddUsers', function () {
            this.ignore()
          })
          .forMember('canManageBonuses', function () {
            this.ignore()
          })
          .forMember('canEcxecuteRequests', function () {
            this.ignore()
          })
          .forMember('password', function () {
            this.ignore()
          })
      },
      computed:{
        ...mapGetters({
          carModels:"Cars/getModels",
          webUserInfo:"userData/getWebUser"
        }),

          fields() {
              let fields = [
                  {text: 'ФИО', value: 'fullName'},
                  {text: 'Статус', value: 'clientStatusName'},
                  {text: 'Машина', value: 'carName'},
                  {text: 'Пакет', value: 'bonusPacketName'},
                  {text: 'Дата продажи', value: 'registerDateTime'},
                  {text: 'Продавец', value: 'webUser'},
              ]
              if (this.canEdit) {
                  fields.push({text: '', value: 'edit'})
              }
              return fields
          },

          canEdit(){
            return this.$route.name=="Clients"
          },

        filteredItems() {
            var items = this.$store.state.Clients.mobileUsers;
            if (items != null) {
                if (this.selectedPackages.length > 0)
                    return items.filter((elem) => {
                        var intersection = this.selectedPackages.indexOf(elem.bonusPacketId) != -1;
                        if (intersection == true)
                            return true
                        else false
                    });
                else return []
            }
            else return [];
        },

          packages(){
            return this.$store.state.Bonuses.bonusPackages
          },

          icon () {
              if (this.likesAllBonuses) return 'mdi-close-box'
              if (this.likesSomeBonuses) return 'mdi-minus-box'
              return 'mdi-checkbox-blank-outline'
          },

          likesSomeBonuses () {
              return this.selectedPackages.length > 0 && !this.likesAllBonuses
          },

          likesAllBonuses() {
              return this.selectedPackages.length === this.packages.length
          },

      },
      methods: {
          hideDetails(isSave){
            this.showClientDetails=false
              if(isSave){
                  this.$store.dispatch("Clients/loadMobileUsers").catch(err => {
                      console.log(err)
                      this.$bvToast.toast(err.message, {
                          title: `Ошибка загрузки списка пользователей!`,
                          variant: "danger",
                          toaster: 'b-toaster-bottom-right',
                          autoHideDelay: 3000,
                          solid: true
                      })
                  });
              }
          },

          //форматирование номера телефона
          formatPhone(value, e){
              //оставляем только цифры
              value= value.replace(/\D/,"")
              value=value.replace(/^[0-8]/,"")
              return value.substr(0,10);
          },

          toogleAllBonuses() {
              this.$nextTick(() => {
                  if (this.likesAllBonuses) {
                      this.selectedPackages = []
                  }
                  else {
                      this.selectedPackages = []
                      this.packages.forEach(item => {
                          this.selectedPackages.push(item.id)
                      })
                  }
              })
          },

          showAddModal(){
            this.addModal=true
          },

          showAgreements(){
              window.open(`${docUrl}system/MobileAgreement.pdf`)
          },

          showSubscript(){
              window.open(`${docUrl}system/SubscriptAgreement.docx`)
          },


          closeAddModal(isSave) {
              this.addModal = false
              if (isSave == true) {
                  this.$store.dispatch("Clients/loadMobileUsers").catch(err => {
                      console.log(err)
                      this.$bvToast.toast(err.message, {
                          title: `Ошибка загрузки списка пользователей!`,
                          variant: "danger",
                          toaster: 'b-toaster-bottom-right',
                          autoHideDelay: 3000,
                          solid: true
                      })
                  });
              }
          },

          showDetails(item) {
              this.selected = item
              this.showClientDetails=true
          },

      },
        watch:{
            packages(value){
                if(value.length>0&&!this.likesAllBonuses){
                    this.toogleAllBonuses()
                }
            }
        }

    }
</script>

<style scoped>

</style>
